<template>
  <div class="space-y-24">
    <div class="text-static-default-mid body-1 flex md:justify-center">
      {{ i18n(translations.pageDescription) }}
    </div>
    <div class="space-y-24">
      <PolicyCard v-for="policy in policies" :key="policy.policyId" :policy />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { Policy } from '../../type'

import translations from './PoliciesAndEligibleInsurances.translations'
import PolicyCard from './components/PolicyCard/PolicyCard.vue'

defineProps<{
  policies: Policy[]
}>()

const i18n = useI18n()
</script>
